module.exports = "../static/media/official.c0fccaf4.png";